export const StatusLightPalette: any = {
    1: '#66C9F9',
    2: '#66C9F9',
    3: '#66C9F9',
    4: '#66C9F9',
    5: '#7BDB94',
    6: '#7BDB94',
    7: '#FF7E75',
    8: '#EF67D8',
    9: '#FFAB66',
    10: '#A387F7',
    11: '#838EA0',
    12: '#838EA0',
}

export const StatusLightBorderPalette: any = {
    1: '#36B5F2',
    2: '#36B5F2',
    3: '#36B5F2',
    4: '#36B5F2',
    5: '#62D07F',
    6: '#62D07F',
    7: '#F56E66',
    8: '#E057C9',
    9: '#FCA055',
    10: '#9271F4',
    11: '#6F7B90',
    12: '#6F7B90',
}